import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { City } from './types/City';

interface SearchCityParams {
  languages: string[];
  query: string;
}

export interface SearchCityData {
  [key: string]: City;
}

export type SearchCityCall = (
  data: SearchCityParams,
) => Promise<{ data: SearchCityData }>;

export default (makeCall: MakeCall) => (data: SearchCityParams) =>
  makeCall<SearchCityData>('POST', `/api/v2/geonames/search-city`, {
    data,
  });
